export const getMetaVar = (name: string) => {
  const metaTag = document.querySelector(`meta[name=${name}]`)
  const content = metaTag?.getAttribute("content")
  return content
}
